import '../vendor/jquery.vimeo.api';
import '../vendor/player';

export class EventGrid {
	constructor() {
		this.container = document.querySelector('.eventGrid');
		this.imgs = this.container.querySelectorAll('.eventGrid-img');
		this.modal = null;
	}

	init() {
		this.imgs.forEach((img) => {
			img.addEventListener('click', () => {
				this.onclickVideo(img);
			});
		});
	}

	onclickVideo(element) {
		const videoUrl = element
			.closest('.eventGrid-post')
			.getAttribute('data-video');

		const windowWidthMobile = window.innerWidth < 768 || false;
		const options = {
			url: videoUrl,
			width: windowWidthMobile ? 800 : 1920,
			playsinline: windowWidthMobile ? false : true,
			autoplay: true,
		};
		this.appendModal();
		const videoContainer = this.modal.querySelector(
			'.popinPostVideo-content'
		);
		const videoPlayer = new Vimeo.Player(videoContainer, options);
	}

	appendModal() {
		const modal = `
		<div class="popinPostVideo">
			<div class="popinPostVideo-close"></div>
			<div class="popinPostVideo-content" id="popinVideo"></div>
		</div>
		`;

		this.container.insertAdjacentHTML('beforeend', modal);
		this.modal = this.container.querySelector('.popinPostVideo');

		setTimeout(() => {
			this.modal.classList.add('showed');
			this.addEventCloseModal();
		}, 100);
	}

	addEventCloseModal() {
		this.modal.addEventListener('click', (e) => {
			if (
				e.target.classList.contains('popinPostVideo-content') ||
				e.target.classList.contains('popinPostVideo-close')
			) {
				this.removeModal();
			}
		});
	}

	removeModal() {
		this.modal.classList.remove('showed');

		this.modal.addEventListener('transitionend', () => {
			this.modal.remove();
		});
	}
}
